// Ported over from webstoreapp

const parseDuration = (duration: number) => {
  return {
    days: Math.floor(duration / 1440),
    hours: Math.floor(duration / 60) % 24,
    minutes: Math.floor(duration) % 60
  };
};

export const formatDuration = (duration: number, formatType = DurationFormatType.short, needsSeparator = false) => {
  if (!duration) {
    return '';
  }
  const d = parseDuration(duration);
  let dayText = '';
  let hourText = '';
  let minuteText = '';

  dayText = d.days !== 0 ? ` ${d.days}${formatType.day}${needsSeparator ? ', ' : ''}` : '';
  hourText = d.hours !== 0 ? ` ${d.hours}${formatType.hour}${needsSeparator ? ', ' : ''}` : '';
  minuteText = d.minutes !== 0 ? ` ${d.minutes}${formatType.minute}` : '';

  return (dayText + hourText + minuteText).trim();
};

export const formatDurationSROnly = (duration: number | undefined, t: (key: string) => string) => {
  if (!duration) {
    return '';
  }
  const d = parseDuration(duration);
  let dayText = '';
  let hourText = '';
  let minuteText = '';

  if (d.days) {
    dayText = ` ${d.days} ${d.days > 1 ? t('days') : t('day')}`;
  }
  if (d.hours) {
    hourText = ` ${d.hours} ${d.hours > 1 ? t(' hours') : t(' hour')}`;
  }
  if (d.minutes) {
    minuteText = ` ${d.minutes} ${d.minutes > 1 ? t(' minutes') : t(' minute')}`;
  }
  return (dayText + hourText + minuteText).trim();
};

export const DurationFormatType = {
  short: {
    day: 'd',
    hour: 'h',
    minute: 'm'
  },
  med: {
    day: ' day,',
    hour: ' hr,',
    minute: ' min'
  },
  full: {
    day: ' day(s)',
    hour: ' hour(s)',
    minute: ' minute(s)'
  },
  other: {
    day: ' d',
    hour: ' h',
    minute: ' mins'
  }
};
